import { render, staticRenderFns } from "./SideBarChart.vue?vue&type=template&id=06bac59e&lang=html&"
import script from "./SideBarChart.vue?vue&type=script&lang=js&"
export * from "./SideBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SideBarChart.vue"
export default component.exports